const CannonChannel = ({ channel, zeusAvailable }) => (
  <div style={{ marginBottom: '8px' }}>
    {channel.type === 'analog' || channel.type === 'calculated' ? (
      <>
        {channel.name}: <strong>{zeusAvailable ? `${channel.value} ${channel.units}` : '—'}</strong>
      </>
    ) : (
      <>
        {channel.name}: <strong>{zeusAvailable ? (channel.value === 0 ? channel.text0 : channel.text1) : '—'}</strong>
      </>
    )}
  </div>
);

export default CannonChannel;